import { render, staticRenderFns } from "./CarouselCard.vue?vue&type=template&id=f40ed9b2"
import script from "./CarouselCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./CarouselCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CarouselCard.vue?vue&type=style&index=0&id=f40ed9b2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports